import React from "react";
import NumberFormat from "../../../helpers/number-format";
import OverviewContainer, {
  Section,
  SectionRow,
} from "../../OverviewContainer/OverviewContainer";

const renderOverviewLiner = (size, interiorExterior) => {
  if (size?.id !== 3) {
    return interiorExterior.liner.map((item, index) => (
          <SectionRow key={index}>
            <span>
              {item.label} {item.variant}
            </span>
          </SectionRow>
      ))
  }
  return (
      <>
        <SectionRow>
            <span>
              Fibreglass Liner
            </span>
        </SectionRow>
        <SectionRow>
          <span>Liner colour - {interiorExterior.linerColor?.label}</span>
        </SectionRow>
      </>
  )
}

const Overview = ({
  size,
  heaters,
  interiorexterior,
  accessories,
  totalPrice,
}) => {
  return (
    <OverviewContainer
      title={`${size?.label} Ofuro Hot Tub`}
      titlePrice={`£${NumberFormat(size?.price)}`}
      totalPrice={totalPrice}
    >
      <Section>
        <SectionRow>
          <strong>Heaters</strong>
        </SectionRow>
        <SectionRow>
          <span>
            {heaters.heater?.label} {heaters.heater?.variant}
          </span>
        </SectionRow>
        {heaters.upgrades.map((upgrade, index) => (
            <SectionRow key={index}>
            <span>
              {upgrade.label} {upgrade.variant}
            </span>
            </SectionRow>
        ))}
      </Section>

      <Section>
        <SectionRow>
          <strong>Interior & Exterior</strong>
        </SectionRow>
        <SectionRow>
          <span>{interiorexterior.wood?.label}</span>
        </SectionRow>
        {interiorexterior.woodTreatment.map((item, index) => (
          <SectionRow key={index}>
            <span>{item.label}</span>
          </SectionRow>
        ))}
        {renderOverviewLiner(size, interiorexterior)}
        {interiorexterior.liner.length > 0 && (
          <SectionRow>
            <span>Liner colour - {interiorexterior.linerColor?.label}</span>
          </SectionRow>
        )}
        {size?.id !== 3 && 
          <SectionRow>
            <span>{interiorexterior.seating?.label}</span>
          </SectionRow>
        }
        <SectionRow>
          <span>{interiorexterior.lidCover?.label} lid</span>
        </SectionRow>
      </Section>

      <Section>
        <SectionRow>
          <strong>Accessories</strong>
        </SectionRow>
        {accessories.flueDrain.map((item, index) => (
          <SectionRow key={index}>
            <span>{item.label}</span>
          </SectionRow>
        ))}
        {accessories.electrical.map((item, index) => (
          <SectionRow key={index}>
            <span>
              {item.label} {item.variant}
            </span>
          </SectionRow>
        ))}
        {accessories.wooden.map((item, index) => (
          <SectionRow key={index}>
            <span>
              {item.quantity && `${item.quantity} x `} {item.label}
            </span>
          </SectionRow>
        ))}
        {accessories.waterCare.map((item, index) => (
          <SectionRow key={index}>
            <span>
              {item.label} {item.variant}
            </span>
          </SectionRow>
        ))}
      </Section>
    </OverviewContainer>
  );
};

export default Overview;
